export const NATURAL_SEARCH_FETCH_REQUEST = 'NATURAL_SEARCH:FETCH_REQUEST';
export const NATURAL_SEARCH_FETCH_SUCCESS = 'NATURAL_SEARCH:FETCH_SUCCESS';
export const NATURAL_SEARCH_FETCH_FAILURE = 'NATURAL_SEARCH:FETCH_FAILURE';
export const NATURAL_SEARCH_NEEDS_CLARIFICATION = 'NATURAL_SEARCH:NEEDS_CLARIFICATION';
export const NATURAL_SEARCH_MARK_APPLIED = 'NATURAL_SEARCH:MARK_APPLIED';
export const NATURAL_SEARCH_REHYDRATE = 'NATURAL_SEARCH:REHYDRATE';
